import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import { toast } from "react-toastify";

export class Education extends Component {
    static displayName = Education.name;
    state = {

    };

    componentDidMount() {
        //this.getCard();
    }

    itemChoice = (e, id) => {
        e.preventDefault();
        if (id == 1)
            document.location = 'http://noroncar.ir/instruction/amozsh';
        else if (id == 2)
            document.location = 'http://noroncar.ir/instruction/amozsh#SOAL';
        else if (id == 3)
            document.location = 'https://noroncar.ir/%D9%BE%D8%B4%D8%AA%DB%8C%D8%A8%D8%A7%D9%86%DB%8C'
    }


    render() {

        return (
            <>
                <CustomModal dd="modal-sm" show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="" >
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="MainMenuItem" onClick={(e) => this.itemChoice(e, 1)}>
                                    <img src="/images/education.png" className="imgMainMenu" />
                                    <p className="itemMainMenu">آموزش</p>
                                </div>
                            </div>
                            <div className="col">
                                <div className="MainMenuItem" onClick={(e) => this.itemChoice(e, 2)}>
                                    <img src="/images/Question.png" className="imgMainMenu" />
                                    <p className="itemMainMenu">سوالات</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="MainMenuItem" onClick={(e) => this.itemChoice(e, 3)}>
                                    <img src="/images/call.png" className="imgMainMenu" />
                                    <p className="itemMainMenu">پشتیبان</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">

                            <div className="col">
                                <div className=" d-flex justify-content-center" >
                                    <button className="btn btn-dark" onClick={(e) => this.props.closeModal(e)}>انصراف</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>
        );
    }


}